import { render, staticRenderFns } from "./ech-lottie.vue?vue&type=template&id=1f4b0c7b&"
import script from "./ech-lottie.vue?vue&type=script&lang=js&"
export * from "./ech-lottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports